import { format } from 'date-fns';

export const getCorrectDateFromISO = (date: Date, _format = 'dd.MM.yyyy') => {
	try {
		return format(date, _format);
	} catch (error) {
		return date.toLocaleDateString();
	}
};
